'use strict';
import {
  getCianObjectType,
  getCustomUrlCian,
  getExtraCategory,
  getParentId,
  getCianDealType
} from '../../utils/googleAnalytics';

class GtagEvent {
  constructor ({
    event,
    eventCategory,
    eventAction,
    eventLabel,
    user,
    page,
    products
  }) {
    this.event = event || null;
    this.eventCategory = eventCategory || null;
    this.eventAction = eventAction || null;
    this.eventLabel = eventLabel || null;
    this.user = user || null;
    this.page = page || null;
    this.products = products || null;
  }
}

class GtagEventBuilder extends GtagEvent {
  setEvent (event) {
    this.event = event;
    return this;
  }
  setEventCategory (eventCategory) {
    this.eventCategory = eventCategory;
    return this;
  }
  setEventAction (eventAction) {
    this.eventAction = eventAction;
    return this;
  }
  setEventLabel (eventLabel) {
    this.eventLabel = eventLabel;
    return this;
  }
  setUser (user) {
    if (user.get('token')) {
      this.user = {
        userId: user.getIn(['data', 'id']),
        type: user.getIn(['data', 'isRealtor']) ? 'realtor' : 'owner'
      };
      return this;
    }
    this.user = { type: 'not_authorized' };
    return this;
  }
  setPage (options) {
    this.page = {
      ...options
    };
    return this;
  }
  setProducts (products) {
    if (!products.size) {
      this.products = [];
      return this;
    }

    this.products = products.map((item, index) => {
      return {
        id: item.get('id'),
        brand: !item.get('author') ? null : `${item.getIn(['author', 'id'])}/${item.getIn(['author', 'isRealtor']) ? 'realtor' : 'owner'}`,
        dealType: getCianDealType(item.get('dealType')),
        objectType: getCianObjectType(item.get('realtyType'), Number(item.get('objectTypeId'))),
        category: `${getCianDealType(item.get('dealType'))}/${getCianObjectType(item.get('realtyType'), Number(item.get('objectTypeId')))}`,
        region: item.getIn(['location', 'region', 'fullName']).replace(/\.$/, ''),
        owner: item.getIn(['author', 'userTypeId']) === 3,
        customURL: getCustomUrlCian(item),
        parentId: getParentId(item),
        position: index + 1,
        extra: {
          category: getExtraCategory(item.get('dealType'), item.get('realtyType'), Number(item.get('objectTypeId')))
        }
      };
    }).toJS();
    return this;
  }
  getEvent () {
    if (!this.event) {
      throw new Error(`${this.constructor.name} получил некорректное значение event`);
    } else if (!this.eventCategory) {
      throw new Error(`${this.constructor.name} получил некорректное значение eventCategory`);
    } else if (!this.eventAction) {
      throw new Error(`${this.constructor.name} получил некорректное значение eventAction`);
    } else if (!this.eventLabel) {
      throw new Error(`${this.constructor.name} получил некорректное значение eventLabel`);
    } else if (!this.user.type) {
      throw new Error(`${this.constructor.name} получил некорректный объект user`);
    } else if (!this.page.pageType && !this.page.siteType) {
      throw new Error(`${this.constructor.name} получил некорректный объект page`);
    }
    // else if (this.products && !this.products.size) {
    //   throw new Error(`${this.constructor.name} получил некорректный объект products`);
    // }
    const obj = new GtagEventBuilder(this);
    return Object.keys(obj)
    .filter((k) => obj[k] != null)
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
  }
}
export default GtagEventBuilder;



// WEBPACK FOOTER //
// ./src/classes/builder/gtagEventBuilder.js